"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _filter = _interopRequireDefault(require("lodash/filter"));

var _map = _interopRequireDefault(require("lodash/map"));

var _fieldResolver = _interopRequireDefault(require("./../helpers/field-resolver"));

var _propertyEditorInternalContext = _interopRequireDefault(require("./../contexts/property-editor-internal-context"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var RestFields = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(RestFields, _Component);

  var _super = _createSuper(RestFields);

  function RestFields() {
    (0, _classCallCheck2["default"])(this, RestFields);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(RestFields, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.context.hasRestFields();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var fieldsToRender = (0, _filter["default"])(this.context.fields, function (field) {
        return _this.context.visibleFieldIds.indexOf(field.fieldId) === -1;
      });
      return (0, _map["default"])(fieldsToRender, function (field) {
        // do not register this field, otherwise it will disapear on the second render
        field.doNotRegisterMe = true;
        field.noCol12 = _this.props.noCol12;
        return _fieldResolver["default"].resolve(field, _this.context.fieldPortalValuesOnlyUseForFieldPortalsAllOtherUseCasesWillBreakTheControlledPropertyEditor[field.fieldId], _this.context.additionalFieldTypes);
      });
    }
  }]);
  return RestFields;
}(_react.Component);

RestFields.propTypes = {
  noCol12: _propTypes["default"].bool
};
RestFields.contextType = _propertyEditorInternalContext["default"];
var _default = RestFields;
exports["default"] = _default;